export const ErrorMessages = {
  GENERAL:
    "An unexpected error ocurred. We have been notified and are working on it. Please try again later.",
} as const;
